import { useDeleteLicenceMutation } from "@sso/apis/licences";
import { DialogTitle } from "@sso/constant";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectDialog } from "@sso/store/slices/dialog";

import { DialogActionButtons, DialogBody, DialogHeader } from "../components";

const LicenceDeleteDialog = () => {
    const { id } = useAppSelector(selectDialog);

  const [deleteLicence, { isLoading }] = useDeleteLicenceMutation();
    
  const handleDeleteAction = () => {
    if (!id) {
      return;
    }
    deleteLicence(id as string);
  };
    
    return <>
         <DialogHeader title={DialogTitle.DELETE_LICENCE} />
         <DialogBody display="initial">
         Are you sure to delete this Licence?
         </DialogBody>
         <DialogActionButtons loading={isLoading} buttonTitle={"Delete"} onClickAction={handleDeleteAction} />
    </>;
};

export default LicenceDeleteDialog;